import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-valeurs-clefs',
  templateUrl: './valeurs-clefs.component.html',
  styleUrls: ['./valeurs-clefs.component.scss']
})
export class ValeursClefsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
